<template>
  <div>
    <a class="title"
       :href="value.url"
       :target="target"
    >{{value.title}}</a>&nbsp;
    <a class="artist"
       :href="value.url"
       :target="target"
    >{{value.artist}}</a>&nbsp;
    <a class="v-btn v-btn--small" @click.prevent="onChordChart" small>Chord Chart</a>
    <a class="v-btn v-btn--small" @click.prevent="onLyrics" small>Lyrics</a>
    <span class="noshow">{{value.title}} chords</span>
  </div>
</template>

<script>
  export default {
    name: "Collection",
    data: function () {
      return {
        // target: '_blank',
        target: '_self',
      }
    },
    props: {
      value: {type: Object},
    },
    methods: {
      onChordChart() {
        open(this.value.url, this.target)
      },
      onLyrics() {
        this.$emit('search-wikia', this.value)
      },
    }
  }
</script>

<style>
  * {
    box-sizing: border-box;
  }

  .title {
    font-size: 24px;
  }

  .artist {
    margin-left: 8px;
    font-size: 16px;
    font-style: italic;
  }

  .noshow {
    display: none;
    /*visibility: hidden;*/
  }
</style>